<template>
  <div style="position: relative;">
    <div v-if="item.is_new" class="image-viewer--new" :class="isNewImgClass">
      <img :src="isNewImg">
    </div>
    <div v-if="item.rating_eu" class="image-viewer--rating">
      <RatingIcon :value="item.rating_eu" :mlb2="true"></RatingIcon>
    </div>
    <v-img :src="item.media && item.media.sm ? item.media.sm : item.image"
      class="program-image"
      aspect-ratio="0.64"
      @click="$emit('click')"></v-img>
  </div>
</template>

<script>
import RatingIcon from '@/components/RatingIcon'

let isNewImg = require('@/assets/is-new3.svg')

if (process.env.VUE_APP_HUN) {
  isNewImg = require('@/assets/is-new.svg')
}

export default {
  components: { RatingIcon },
  data: () => ({
    isNewImg,
    isNewImgClass: process.env.VUE_APP_HUN === 'true' ? 'hun' : 'cz',
  }),
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>
  $space: .2rem;
  .image-viewer--new,
  .image-viewer--rating {
    position: absolute;
  }
  .image-viewer--new {
    top: 0;
    right: 0;
    width: 35%;
    z-index: 1;
    position: absolute !important;
    pointer-events: none;
  }
  .image-viewer--rating {
    bottom: 0;
    right: $space;
    width: 15%;
    z-index: 1;
    position: absolute;
    pointer-events: none;
  }
</style>
<style>
  .program-image {
    box-shadow: 0 0 10px rgba(55,55,55,.6);
    border-radius: 0;
    border: 1px solid white;
  }
  .program-image * {
    transition: transform 220ms ease-in-out;
    will-change: transform;
  }
  .program-image:hover * {
    transform: scale(1.05);
  }
  .image-viewer--new {
    position: absolute !important;
  }
</style>
